import { fontFamilyBold, header } from '../mixins/typography';
import { css } from 'styled-components';

export default css`
  h1 {
    ${header('h1')};
  }
  h2 {
    ${header('h2')};
  }
  h3 {
    ${header('h3')};
  }
  h4 {
    ${header('h4')};
  }
  h5 {
    ${header('h5')};
  }
  h6 {
    ${header('h6')};
  }
  .bold {
    ${fontFamilyBold}
  }
  .text-theme-light {
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      color: white;
    }
  }
`;
